import Drawer from '@/component/Drawer'
import Modal from '@/component/Modal'
import useRuntime from '@/hook/useRuntime'
import useStatePopup from '@/hook/useStatePopup'
import { PopupSelector, PopUpStore } from '@/store/PopupStore'
import { TGASDK } from '@kulee/tga-sdk'
import React from 'react'
import { useTranslation } from 'react-i18next'
import ShareMain from './ShareMain'

const PayPopup: React.FC<PropType> = () => {
  const { t } = useTranslation('share')
  const { client, lang } = useRuntime()
  const { visible, params } = useStatePopup(PopupSelector.sharePopup)

  const handleClose = () => {
    PopUpStore.setSharePopup({ visible: false, params: undefined, onFinish: undefined })
  }

  if (client === 'mobile') {
    // 计算高度
    const channelLen = TGASDK.context.appConfig.feature.share.channels?.length || 0
    const textLen = Math.ceil(params?.text.length || 0 / 15)
    const height = Math.ceil(textLen / (lang === 'zh' ? 15 : 30)) * 24 + Math.ceil(channelLen / 4) * 88 + 140

    return (
      <Drawer
        visible={visible}
        placement="bottom"
        height={height}
        zIndex={910}
        onClose={handleClose}
        lockScroll={true}
        destroyOnClose
        className="bg-primary-extralight"
        title={t('modalTitle.share')}
      >
        <div className="h-full px-md">
          <ShareMain />
        </div>
      </Drawer>
    )
  }

  return (
    <Modal
      visible={visible}
      zIndex={910}
      width={480}
      destroyOnClose
      onCancel={handleClose}
      footer={null}
      icon={false}
      closable
      title={t('modalTitle.share')}
    >
      <ShareMain />
    </Modal>
  )
}

interface PropType {}

export default PayPopup
